import { render, staticRenderFns } from "./RecordingConsentSettings.vue?vue&type=template&id=25cc7394&scoped=true"
import script from "./RecordingConsentSettings.vue?vue&type=script&lang=js"
export * from "./RecordingConsentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cc7394",
  null
  
)

export default component.exports